<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="报销单号：">
          <el-input v-model="formInline.code" placeholder="请输入报销单编号" clearable size="small"
            @change="inputChange"></el-input>
        </el-form-item>
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报销人：">
          <el-select v-model="formInline.userKeyId" placeholder="请选择报销人" clearable filterable size="small"
            @change="inputChange">
            <el-option v-for="item in userList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报销时间：">
          <el-date-picker clearable v-model="dateValue" size="small" type="daterange" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd" @change="handleDateChange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报销内容：">
          <el-input v-model="formInline.content" placeholder="请输入报销内容" clearable size="small"
            @change="inputChange"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/reimbursement/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/reimbursement/index', 'create')" size="small" type="primary"
            class="el-icon-plus" @click="handleEdit()">新增
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/reimbursement/index', 'export')" size="small" type="warning"
            class="el-icon-download" @click="handleExport()">导出
          </el-button>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" @rowDBClick="handleEdit"
        border stripe>
        <el-table-column align="center" slot="isConfirm" label="是否审核" width="120" fixed="left">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isConfirm" type="success">已审核</el-tag>
            <el-tag v-else type="danger">未审核</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="isPay" label="是否支付" width="120" fixed="left">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isPay" type="success">已支付</el-tag>
            <el-tag v-else type="danger">未支付</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="operation" label="操作" width="170"
          v-if="btnPermission.confirm || btnPermission.pay" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isConfirm == false && btnPermission.confirm" size="mini" type="primary"
              class="el-icon-finished" @click="handleConfirm(scope.row)">审核</el-button>
            <el-button v-else-if="scope.row.isPay == false && btnPermission.pay && scope.row.isConfirm == true"
              size="mini" type="primary" class="el-icon-mouse" @click="handlePay(scope.row)">支付</el-button>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑 -->
    <edit ref="edit"></edit>
  </div>
</template>

<script>
import {
  GetReimbursementPageList,
  ConfirmReimbursement,
  PayReimbursement,
  ExportReimbursement
} from "@/api/storeCostApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
import edit from "./edit.vue";
import { downloadFile } from "@/utils/export.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "报销记录",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
        content: "",
        code: "",
        userKeyId: "",
        startTime: null,
        endTime: null,
      },
      storeList: [],
      columnsData: [],
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "120",
          fixed: "left",
          align: "center",
        },
        {
          prop: "costDate",
          label: "报销日期",
          isKeep: true,
          minWidth: "120",
          fixed: "left",
          align: "center",
        },
        {
          prop: "code",
          label: "报销单号",
          isKeep: true,
          minWidth: "180",
          fixed: "left",
          align: "center",
        },
        {
          slot: "isConfirm",
          label: "是否确认",
          width: "120",
          fixed: "left",
          align: "center",
        },
        {
          slot: "isPay",
          label: "是否支付",
          width: "120",
          fixed: "left",
          align: "center",
        },
        {
          prop: "content",
          label: "开支内容",
          minWidth: "200",
          align: "center",
        },
        {
          prop: "money",
          label: "金额",
          width: "120",
          align: "center",
        },
        {
          prop: "payUserTypeName",
          label: "支付方式",
          width: "120",
          align: "center",
        },
        {
          prop: "creator",
          label: "报销人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "报销时间",
          width: "170",
          align: "center",
        },
        {
          prop: "remark",
          label: "报销备注",
          width: "170",
          align: "center",
        },
        {
          prop: "confirmUserName",
          label: "确认人",
          width: "120",
          align: "center",
        },
        {
          prop: "confirmTime",
          label: "确认时间",
          width: "170",
          align: "center",
        },
        {
          prop: "payUserName",
          label: "支付人",
          width: "120",
          align: "center",
        },
        {
          prop: "payTime",
          label: "支付时间",
          width: "170",
          align: "center",
        },
        {
          slot: "operation",
          label: "操作",
          width: "170",
          align: "center",
        },
      ],
      btnPermission: {
        confirm: false,
        pay: false,
      },
      userList: [],
      dateValue: [],
    };
  },
  // 注册组件
  components: {
    edit,
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetOrgInfoListByConfig();
    this.GetUserBindSelectByPermission();
    // 按钮权限
    this.btnPermission.confirm = this.$checkBtnPermission('/reimbursement/index', 'confirm');
    this.btnPermission.pay = this.$checkBtnPermission('/reimbursement/index', 'pay');
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            res.data.forEach((item) => {
              this.storeList.push({
                keyId: item.keyId,
                value: item.name + '【' + item.remark2 + '】',
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    //显示编辑界面
    handleEdit(row) {
      this.$refs.edit.editShow(row);
    },
    handleDateChange(val) {
      if (val) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
      this.getListData();
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetReimbursementPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission() {
      const paramer = {};
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.userList = [];
            if (res.code == 1) {
              this.userList = res.data;
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 确认
    handleConfirm(row) {
      ConfirmReimbursement({
        keyId: row.keyId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "确认成功",
            });
            this.getListData();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("确认失败，请稍后再试！");
        });
    },
    // 支付
    handlePay(row) {
      PayReimbursement({
        keyIds: [row.keyId],
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "支付成功",
            });
            this.getListData();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("支付失败，请稍后再试！");

        }).finally(() => {
          this.loading = false;
        });
    },
    // 导出
    handleExport() {
      ExportReimbursement(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "导出成功",
            });
            downloadFile(res.data, "报销单.xlsx");
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("导出失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped></style>